import { useTranslation } from "react-i18next";
import { Table } from "react-bootstrap";

// Const
import { userType } from "const/nuclias/user";

// Component
import TooltipDialogFixed from "components/TooltipDialogFixed";
import Checkbox from "components/Checkbox";
import ButtonAction from "components/ButtonAction";

const SamlRolesTable = (props) => {
  const {
    tableRef,
    stickyStyle,
    tableHeader,
    selectedPage,
    selectedPageLimit,
    currentSamlRoleList,
    changeModalStatus,
    checkedAllState,
    toggleCheckedAll,
    toggleChecked,
    selectSamlRoleCallback,
    handleDelete
  } = props;

  const { t } = useTranslation();

  const showManagedScope = (samlRole) => {
    if (samlRole.managedScope.length === 0 && samlRole.accessLevel === userType.si) {
      return t('b1c94ca2fb');
    } else {
      let html = '';

      for (const name of samlRole.managedScope) {
        html += `<div class='pb-1'>${name}</div>`;
      }

      return (
        <TooltipDialogFixed
          className="ms-1 me-1"
          hideIcon={true}
          placement="right"
          tooltipsTitle={samlRole.managedScope.length}
          title={html}
        />
      );
    }
  }

  return (
    <Table responsive striped hover className="table-container" ref={tableRef}>
      <thead style={stickyStyle}>
        <tr>
          <th>
            <Checkbox
              id="rl-th-saml-role"
              type='checkbox'
              checked={checkedAllState()}
              onChange={toggleCheckedAll}
            />
          </th>
          <th>#</th>
          {tableHeader()}
          <th>
            {t('06df33001c')}
          </th>
        </tr>
      </thead>
      <tbody>
        {currentSamlRoleList && currentSamlRoleList.map((samlRole, index) => {
          return (
            <tr key={index}>
              <td>
                <Checkbox
                  id={`rl-cb-smal-${index}`}
                  type='checkbox'
                  checked={samlRole.checked === true}
                  onChange={() => toggleChecked(index)}
                />
              </td>
              <td>{((selectedPage - 1) * selectedPageLimit) + index + 1}</td>
              <td>{samlRole.name}
              </td>
              <td>{t(samlRole.role)}</td>
              <td>{showManagedScope(samlRole)}</td>
              <td className={'table-action-td'}>
                <ButtonAction
                  label="7e77616685"
                  iconClassName="icon-edit"
                  onClick={() => {
                    selectSamlRoleCallback(samlRole);
                    changeModalStatus('addAndEdit', true);
                  }}
                />
                <ButtonAction
                  label="ce64bbe3ba"
                  iconClassName="icon-trash"
                  onClick={() => {
                    handleDelete(samlRole.id);
                    changeModalStatus('delete', true);
                  }}
                />
              </td>
            </tr>
          )
        })}
        {currentSamlRoleList.length === 0 && (
          <tr>
            <td colSpan="6" className="no-data">
              {t('ad01242a61')}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default SamlRolesTable;
